export const GET_ALL_SUBSCRIPTIONS = 'GET_ALL_SUBSCRIPTIONS';
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const GET_PUNTER_SUBSCRIPTIONS = 'GET_PUNTER_SUBSCRIPTIONS';
export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
export const FETCH_HISTORY = "FETCH_HISTORY";